import * as React from "react";
const SvgFiRrHouseReturn = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-house-return_svg__a)">
      <path
        fill="#062147"
        d="M14 2.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M8 15H4c-1.103 0-2-.897-2-2V7.662c0-.929.419-1.79 1.151-2.362l3.324-2.601c1.062-.832 2.501-.932 3.607-.296l.498.337a1 1 0 1 0 1.121-1.657l-.558-.375a5.26 5.26 0 0 0-5.901.415L1.918 3.724A4.97 4.97 0 0 0 0 7.662V13c0 2.206 1.794 4 4 4h4a1 1 0 0 0 0-2M5 9a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zm19 2.556V14a1 1 0 1 1-2 0v-2.444a1 1 0 0 0-.436-.825L20 9.662v3.797c0 .978-.479 1.897-1.28 2.458l-4.271 2.824a1 1 0 0 0-.449.834V23a1 1 0 1 1-2 0v-3.425a2.99 2.99 0 0 1 1.346-2.502L14 16.64v-3.867l-2.399 1.565a1 1 0 1 1-1.092-1.676l2.437-1.589a1 1 0 0 0 .417-.568s.693-2.472.709-2.512c.406-1.127 1.625-1.976 2.833-1.976 1.444 0 2.247.574 2.548.848l3.24 2.214A3 3 0 0 1 24 11.556m-6-3.292c-.154-.094-.496-.248-1.096-.248-.33 0-.746.259-.904.542v6.759l1.595-1.055a.99.99 0 0 0 .405-.805zm1.784 10.356a1 1 0 1 0-1.85.759l1.641 4a1 1 0 0 0 1.305.546 1 1 0 0 0 .545-1.305z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-house-return_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHouseReturn;
